import React, { FC, memo, useEffect, useState } from 'react'

import { useSetFocus } from '@please/lrud'
import { useNavigate } from 'react-router-dom'

import {
  Actions,
  AuthPopupContainer,
  AuthPopupContent,
  ContentContainer,
} from '@/components/AuthPopup/styles'
import { Button } from '@/components/Button/Button'
import { focusIds, orientation } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { SessionStatus } from '@/constants/login'
import { Auth } from '@/containers/Auth/Auth'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import useStore from '@/store/useStore'

const AuthPopupRaw: FC = () => {
  const navigate = useNavigate()
  const setFocus = useSetFocus()
  const { t } = useCommonTranslation()
  const authPopup = useStore((state) => state.common.authPopup)
  const closePagePopup = useStore((state) => state.popup.closePagePopup)
  const setPage = useStore((state) => state.page.setPage)
  const setAuthPopup = useStore((state) => state.common.setAuthPopup)
  const setListPopup = useStore((state) => state.common.setListPopup)
  const setCurrentEvent = useStore((state) => state.common.setCurrentEvent)
  const [sessionStatus, setSessionStatus] = useState<SessionStatus>()

  useEffect(() => {
    if (authPopup) {
      setTimeout(setFocus, 0, focusIds.AUTH_POPUP)
    }
  }, [authPopup])

  if (!authPopup) {
    return null
  }

  const clearPopups = () => {
    setPage(null)
    closePagePopup()
    setCurrentEvent(null)
    setListPopup(null)
  }

  const closeHandler = (isLoginComplited?: boolean) => {
    if (isLoginComplited) {
      clearPopups()
      authPopup.onSuccessHandler?.()
      authPopup.redirectPath
        ? navigate(authPopup.redirectPath)
        : setFocus(authPopup.prevFocusId)
    } else {
      setFocus(authPopup.prevFocusId)
    }
    setAuthPopup(null)
  }

  const isActionsDisabled = sessionStatus === SessionStatus.AUTHENTICATED

  return (
    <AuthPopupContainer
      orientation={orientation.VERTICAL}
      focusId={focusIds.AUTH_POPUP}
      isTrap={true}
    >
      <AuthPopupContent>
        <ContentContainer disabled={sessionStatus !== SessionStatus.EXPIRED}>
          <Auth
            sessionType={authPopup.sessionType}
            isPopup
            setPopupSessionStatus={setSessionStatus}
            closeHandler={closeHandler}
          />
        </ContentContainer>
        <Actions $isDisabled={isActionsDisabled}>
          <Button
            iconSrc={icons.navigation.exit}
            text={t('close')}
            onClick={() => {
              !isActionsDisabled && closeHandler()
            }}
          />
        </Actions>
      </AuthPopupContent>
    </AuthPopupContainer>
  )
}

export const AuthPopup = memo(AuthPopupRaw)
